import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { DEFAULT_CONTENT_WIDTH } from '../../../../../constants';
import { CitiesList } from './components/cities-list';
import { HeroIcons } from '@/components/design-system/atoms/icon';

const DiscoverYourNewHomeSection = () => {
  const { t } = useTranslation();
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  // Handle scroll state changes from the carousel
  const handleScrollStateChange = useCallback(
    (canLeft: boolean, canRight: boolean) => {
      setCanScrollLeft(canLeft);
      setCanScrollRight(canRight);
    },
    []
  );

  // Trigger scroll via custom event (decoupled from carousel implementation)
  const handleScrollClick = (direction: 'left' | 'right') => {
    if (typeof window === 'undefined') return;

    const event = new CustomEvent('cities-carousel-scroll', {
      detail: { direction },
    });
    window.dispatchEvent(event);
  };

  return (
    <section className="w-full overflow-hidden bg-bg-primaryLight">
      <div className={clsx(DEFAULT_CONTENT_WIDTH, 'm-auto flex-1')}>
        <div className="mt-8 flex w-full items-center justify-between">
          <h1 className={clsx(
            'text-h3 font-bold text-text-primary',
            'leading-[3.7rem]',
            'sm:text-[4.8rem] sm:leading-[5.5rem]'
          )}>
            {t('js.features.marketplace.home.section2.title')}
          </h1>
          <div className="ml-4 hidden gap-4 md:flex">
            <button
              className={clsx(
                'flex items-center justify-center',
                'h-8 w-8',
                'rounded-full border border-border-primaryLight',
                'transition-all',
                canScrollLeft
                  ? 'cursor-pointer hover:bg-E60'
                  : 'cursor-not-allowed opacity-40'
              )}
              aria-label="Scroll left"
              onClick={() => handleScrollClick('left')}
              disabled={!canScrollLeft}
              type="button"
            >
              <HeroIcons name="arrow-left" size={20} strokeColor="#495057" strokeWidth={3} />
            </button>
            <button
              className={clsx(
                'flex items-center justify-center',
                'h-8 w-8',
                'rounded-full border border-border-primaryLight',
                'transition-all',
                canScrollRight
                  ? 'cursor-pointer hover:bg-E60'
                  : 'cursor-not-allowed opacity-40'
              )}
              aria-label="Scroll right"
              onClick={() => handleScrollClick('right')}
              disabled={!canScrollRight}
              type="button"
            >
              <HeroIcons name="arrow-right" size={20} strokeColor="#495057" strokeWidth={3} />
            </button>
          </div>
        </div>
      </div>
      <CitiesList onScrollStateChange={handleScrollStateChange} />
    </section>
  );
};

export { DiscoverYourNewHomeSection };
